import axios from 'axios';

const loginService = {
  login(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/auth', credentials)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loginMSAL(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/msalauth', credentials)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  identifierLogin(credentials) {
    var url = '/identifier';
    return new Promise((resolve, reject) => {
      axios
        .post(url, credentials)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  alterPassword(params) {
    var url = '/savePassword';
    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default loginService;
